export const TrialTypeDecorator = {
  url() {
    return `signup-hubspot/trial`;
  },

  query() {
    return {};
  }

};